import React from 'react';
import { Form, Button, InputGroup, Card } from 'react-bootstrap';
import { Search, Calendar, Download } from 'lucide-react';

const PaymentLogsFilter = ({
  search,
  setSearch,
  statusFilter,
  setStatusFilter,
  gatewayFilter,
  setGatewayFilter,
  gatewayOptions,
  dateRange,
  setDateRange
}) => {
  return (
    <Card.Body className="p-4 bg-transparent admin-payments-border-bottom">
      <div className="row g-3">
        <div className="col-lg-4 col-md-6">
          <InputGroup className="border-0 rounded-3 admin-payments-input-group">
            <InputGroup.Text className="bg-transparent border-0 text-secondary">
              <Search size={18} />
            </InputGroup.Text>
            <Form.Control
              type="text"
              placeholder="Search by User, Payment ID, Order ID..."
              className="bg-transparent border-0 shadow-none ps-0 admin-payments-input"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </InputGroup>
        </div>
        <div className="col-lg-2 col-md-3">
          <Form.Select className="border-0 rounded-3 text-white py-2 admin-payments-select" value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
            <option value="All Statuses">All Statuses</option>
            <option value="SUCCESS">SUCCESS</option>
            <option value="BOOKED">BOOKED</option>
            <option value="PENDING">PENDING</option>
            <option value="FAILED">FAILED</option>
          </Form.Select>
        </div>
        <div className="col-lg-2 col-md-3">
          <Form.Select className="border-0 rounded-3 text-white py-2 admin-payments-select" value={gatewayFilter} onChange={(e) => setGatewayFilter(e.target.value)}>
            <option value="All Gateways">All Gateways</option>
            {gatewayOptions && gatewayOptions.length > 0 ? (
              gatewayOptions.map((gw, idx) => (
                <option key={idx} value={gw.value || gw.key}>{gw.label || gw.value || gw.key}</option>
              ))
            ) : (
              <>
                <option value="Razorpay">Razorpay</option>
                <option value="PhonePe">PhonePe</option>
              </>
            )}
          </Form.Select>
        </div>
        <div className="col-lg-2 col-md-6">
          <InputGroup className="border-0 rounded-3 admin-payments-input-group">
            <InputGroup.Text className="bg-transparent border-0 text-secondary">
              <Calendar size={18} />
            </InputGroup.Text>
            <Form.Control
              type="text"
              placeholder="Select Date Range"
              className="bg-transparent border-0 shadow-none ps-0 admin-payments-input"
              value={dateRange}
              onChange={(e) => setDateRange(e.target.value)}
              disabled
            />
          </InputGroup>
        </div>
        <div className="col-lg-2 col-md-6 text-end">
          <Button variant="outline-secondary" className="admin-payments-btn-secondary" onClick={() => window.print()}>
            <Download size={18} /> Export / Print
          </Button>
        </div>
      </div>
    </Card.Body>
  );
};

export default PaymentLogsFilter;
